export enum LanguageCodeList {
    bg = 'bg',
    cs = 'cs',
    da = 'da',
    de = 'de',
    de_soc = 'de_soc',
    el = 'el',
    en = 'en',
    en_soc = 'en_soc',
    es = 'es',
    es_soc = 'es_soc',
    et = 'et',
    fi = 'fi',
    fr = 'fr',
    hr = 'hr',
    hu = 'hu',
    id = 'id',
    it = 'it',
    ja = 'ja',
    ko = 'ko',
    nl = 'nl',
    no = 'no',
    pl = 'pl',
    pt = 'pt',
    'pt-br' = 'pt-br',
    ro = 'ro',
    ru = 'ru',
    sk = 'sk',
    sv = 'sv',
    th = 'th',
    tr = 'tr',
    vi = 'vi',
    zh = 'zh',
    're-en' = 're-en'
}
